/**
 * @author       grady@zumper.com (Grady Kuhnline)
 * @copyright    Copyright (c) 2021, Zumper
 * @description  settings.ts
 */

import { getLiveEnv } from '@zcode/env'

export const STATIC_CDN_URL =
  process.env.REACT_APP_STATIC_CDN_URL ??
  'https://d214hhm15p4t1d.cloudfront.net'

export const IMAGE_STATIC_CDN_URL =
  process.env.REACT_APP_IMAGE_STATIC_CDN_URL ?? 'https://static.zumpercdn.com'

const fallbackMediaCdnUrl = 'https://img.zumpercdn.com'

export const MEDIA_CDN_URL =
  getLiveEnv('REACT_APP_MEDIA_CDN_URL') ?? fallbackMediaCdnUrl
